import React from 'react'
import AppoinmentForm from '../Components/MyMedicineAppoinForm/AppoinmentForm'

const AppoinmentFormView = () => {
  return (
    <div>
        <AppoinmentForm />
    </div>
  )
}

export default AppoinmentFormView